import React from 'react';
import { useSettings } from '../../../hooks/admin/useSettings';
import { SettingsCard } from './SettingsCard';

export function IntegrationSettings() {
  const { settings, updateSettings, isLoading } = useSettings('integrations');

  return (
    <SettingsCard
      title="Integration Settings"
      description="Configure third-party service integrations"
      isLoading={isLoading}
    >
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-white mb-2">
            Google Analytics ID
          </label>
          <input
            type="text"
            value={settings?.googleAnalyticsId || ''}
            onChange={(e) => updateSettings({ googleAnalyticsId: e.target.value })}
            className="input w-full"
            placeholder="UA-XXXXXXXXX-X"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-white mb-2">
            Intercom App ID
          </label>
          <input
            type="text"
            value={settings?.intercomAppId || ''}
            onChange={(e) => updateSettings({ intercomAppId: e.target.value })}
            className="input w-full"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-white mb-2">
            Sentry DSN
          </label>
          <input
            type="text"
            value={settings?.sentryDsn || ''}
            onChange={(e) => updateSettings({ sentryDsn: e.target.value })}
            className="input w-full"
          />
        </div>
      </div>
    </SettingsCard>
  );
}